import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Form, Row, Select, Spin, Typography, message, theme } from 'antd'

// slices
import { workSpaceAssign } from '../workSpace/workSpace.slice'
import { talentState, roleList } from './talent.slice'

// components
import Button from '../../components/button/button'

const WorkspaceAssignModal = ({ cancelModal, refreshTalent }) => {
    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const [form] = Form.useForm()

    const { selectedData } = useSelector(talentState)

    const [fetching, setFetching] = useState(false)
    const [roleOptions, setRoleOptions] = useState([])
    const [buttonLoading, setButtonLoading] = useState(false)

    const { Title } = Typography

    // FETCH ROLES
    useEffect(() => {
        const fetchRoles = async () => {
            setFetching(true)
            const result = await dispatch(
                roleList({
                    isWorkspaceRole: true,
                })
            )
            const data = result?.payload?.data

            if (data) {
                if (data?.length > 0) {
                    const options = data.map((role) => {
                        return {
                            label: role?.roleName,
                            value: role?._id,
                        }
                    })
                    setRoleOptions(options)
                }
            }
            setFetching(false)
        }
        fetchRoles()
    }, [dispatch])

    // ASSIGN WORKSPACE
    const assignWorkSpace = async (value) => {
        setButtonLoading(true)
        const result = await dispatch(
            workSpaceAssign({
                userId: selectedData?._id,
                roleId: value?.role,
            })
        )
        const data = result?.payload?.data

        setButtonLoading(false)

        if (data) {
            const { success, message: checkMessage } = data
            if (success) {
                message.success(
                    checkMessage || 'Workspace assigned successfully'
                )
                refreshTalent()
                cancelModal()
            } else {
                message.error(
                    checkMessage || 'Something went wrong, try again later.'
                )
                cancelModal()
            }
        } else {
            message.error('Something went wrong, try again later.')
            cancelModal()
        }
    }

    function onFinishFailed() {}

    return (
        <>
            <Title
                level={4}
                style={{
                    textAlign: 'center',
                }}
            >
                Assign Workspace
            </Title>
            <Form
                name="assignWorkSpace"
                onFinish={assignWorkSpace}
                onFinishFailed={onFinishFailed}
                form={form}
                requiredMark={false}
            >
                <Form.Item
                    name={'role'}
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Role',
                        },
                    ]}
                >
                    <Select
                        placeholder="Select Role"
                        style={{
                            width: '100%',
                            marginTop: '33px',
                        }}
                        loading={fetching}
                        notFoundContent={
                            fetching ? <Spin size="small" /> : 'No roles found'
                        }
                        options={roleOptions}
                    />
                </Form.Item>
                <Row
                    align={'middle'}
                    justify={'end'}
                    style={{
                        marginTop: '34px',
                    }}
                >
                    <Button
                        props={{
                            text: 'Cancel',
                            onClick: () => cancelModal(),
                            buttonType: 'link',
                            style: {
                                color: token.colorPalette.baseColor.black,
                            },
                        }}
                    />
                    <Button
                        props={{
                            text: 'Assign',
                            htmlType: 'submit',
                            loadingButton: buttonLoading,
                        }}
                    />
                </Row>
            </Form>
        </>
    )
}

export default WorkspaceAssignModal
